import React from 'react';
import { Hero, Navbar, Footer } from '../components';

const NotFound = () => (
  <>
    <Navbar />
    <Hero title="404" subtitle="No hemos encontrado lo que estas buscando" />
    <Footer />
  </>
);

export default NotFound;
